/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import { graphql } from 'react-apollo';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Form,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input
} from 'reactstrap';
import SITE_QUERY from 'graphql/queries/sites';

export class SiteDropdown extends PureComponent {

  render() {
    const { 
      sitesQuery: { sites }, 
    } = this.props;
    return (
      <UncontrolledDropdown className="dropdown dropdown-workspace">
        <DropdownToggle
          aria-expanded={false}
          aria-haspopup
          caret
          className="btn btn-secondary dropdown-toggle"
          color="primary"
          data-toggle="dropdown"
          id="dropdownMenuButton"
          type="button"
        >
          Välj arbetsyta här
        </DropdownToggle>
        <DropdownMenu
          aria-labelledby="dropdownMenuButton"
          right
          className="dropdown-menu"
        >
          <Form className="w-100">
            <InputGroup className="no-border">
              <Input placeholder="Sök..." />
              <InputGroupAddon addonType="append">
                <InputGroupText>
                  <i className="nc-icon nc-zoom-split" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>
          <hr />
          { sites && sites.map(site => (
            <DropdownItem
              key={site.id}
              href="#"
              onClick={e => e.preventDefault()}
            >
              {site.name}
            </DropdownItem>
          ))}
          <hr className="mb-2" />
          <a href="#" className="workspace-edit-link"><i className="fa fa-edit" />Edit Sites</a>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

const SitesWithGraphql = graphql(SITE_QUERY, { name: 'sitesQuery' })(SiteDropdown);

export default SitesWithGraphql;